import React, {createContext, useState} from 'react';
import {Toast} from "../components/common/Toast";
import {getErrorMessage} from "../helpers/Utils";
import FloorService from "../services/FloorService";

export const FloorContext = createContext("FloorContext");

const FloorContextProvider = ({children}) => {

    const [floorList, setFloorList] = useState([]);
    const [totalElements, setTotalElements] = useState(0);
    const [loadingFloorList, setLoadingFloorList] = useState(false);

    const getFloorList = async (id, params) => {

        try {
            setLoadingFloorList(true);
            const response = await FloorService.getFloorList(id, params);
            setFloorList(response.data.content);
            setTotalElements(response.data.totalElements);
            setLoadingFloorList(false);
            return response.data.content;
        } catch (error) {
            setLoadingFloorList(false);
            const message = getErrorMessage(error);
            Toast("error", "Error", message);
            return [];
        }

    }

    return (
        <FloorContext.Provider
            value={{
                getFloorList,
                floorList,
                totalElements,
                loadingFloorList,
            }}
        >
            {children}
        </FloorContext.Provider>
    );
}

export default FloorContextProvider;
